if (!customElements.get("td-header")) {
  class TdHeader extends HTMLElement {
    constructor() {
      super();
      this.wrapper = this.closest(".td-header__wrapper");
      this.isSticky = this.wrapper && this.wrapper.dataset.enableSticky;

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
    
      this.dropdowns = Array.from(this.querySelectorAll(".td-header__has-dropdown"));
      this.dropdownsWrapper = this.querySelector("[data-action='dropdown-on-click']");

      this.megaMenuLinks = Array.from(this.querySelectorAll('.td-header__mega-menu-link'));
      this.megaMenuPanels = Array.from(this.querySelectorAll('.td-header__mega-menu-panel'));
    }
    
    connectedCallback() {
      this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
      window.addEventListener("scroll", this.onScrollHandler, false);
      if (this.isSticky) this.createObserver();

      if (this.dropdownsWrapper)
        this.dropdowns.map((dropdown) =>
          dropdown.addEventListener("click", this.toggleDropdown.bind(this))
        );
      document.addEventListener('click', this.closeDropdowns.bind(this));

      this.setupMegaMenuPanels();
    }

    disconnectedCallback() {
      this.removeEventListener(
        "preventHeaderReveal",
        this.hideHeaderOnScrollUp
      );
      window.removeEventListener("scroll", this.onScrollHandler);
    }
    
    setupMegaMenuPanels() {
      const megaMenus = Array.from(document.querySelectorAll('.td-header__mega-menu'));
      
      megaMenus.forEach(megaMenu => {
        if (megaMenu.classList.contains('td-header__mega-menu--featured-images')) {
          return;
        }
        
        const links = Array.from(megaMenu.querySelectorAll('.td-header__mega-menu-link'));
        const panels = Array.from(megaMenu.querySelectorAll('.td-header__mega-menu-panel'));

        if (links.length > 0 && panels.length > 0) {
          const firstPanel = panels[0];
          const firstLink = links[0];
          
          if (firstPanel.dataset.active === 'true') {
            firstLink.classList.add('is-open');
          }
        }
        
        links.forEach(link => {
          const targetPanel = document.getElementById(link.dataset.target);
          const hasSublinks = targetPanel && 
                             targetPanel.querySelector('.td-header__mega-menu-products') && 
                             targetPanel.querySelector('.td-header__mega-menu-products').children.length > 0;
          
          if (hasSublinks) {
            link.addEventListener('mouseenter', () => {
              links.forEach(l => {
                l.classList.remove('is-open');
              });
              link.classList.add('is-open');
              panels.forEach(panel => {
                panel.dataset.active = 'false';
              });
              if (targetPanel) {
                targetPanel.dataset.active = 'true';
              }
            });
          } else {
            link.classList.add('td-header__mega-menu-link--no-sublinks');
          }
        });
      });
    }

    closeDropdowns(e) {
      if (!e.target.closest('.td-header__menu-item')) {
        this.dropdowns.forEach((dropdown) => {
          dropdown.classList.remove('is-open');
        });
      }
    }

    toggleDropdown(e) {
      const linkWrapper = e.target.closest(".td-header__menu-item");
      this.dropdowns.forEach((dropdown) => {
        if (dropdown != linkWrapper) {
          dropdown.classList.remove("is-open");
        }
      });

      if (linkWrapper) linkWrapper.classList.toggle("is-open");
    }

    hideHeaderOnScrollUp() {
      this.preventReveal = true
    };      

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.wrapper);
    }

    onScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.wrapper.classList.add(
        "td-header__sticky",
        "shopify-announcement-hidden"
      );
      
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.wrapper.getBoundingClientRect().bottom)}px`);
      setTimeout(() => {
        this.wrapper.classList.add("reveal");
      })
    }

    reveal() {
      this.wrapper.classList.add("td-header__sticky", "animate");
      this.wrapper.classList.remove("shopify-announcement-hidden");
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.wrapper.getBoundingClientRect().bottom)}px`);
      setTimeout(() => {
        this.wrapper.classList.add("reveal");
      })
      
    }

    reset() {
      this.wrapper.classList.remove(
        "shopify-section-header-hidden",
        "td-header__sticky",
        "animate",
        "reveal"
      );
      setTimeout(() => {
        this.wrapper.classList.remove("reveal");
      })
    }
  }

  customElements.define("td-header", TdHeader);

  class MenuDrawer extends HTMLElement {
    constructor() {
      super();

      this.mainDetailsToggle = this.querySelector("details");

      this.addEventListener("keyup", this.onKeyUp.bind(this));
      this.addEventListener("focusout", this.onFocusOut.bind(this));
      this.bindEvents();
    }

    bindEvents() {
      this.querySelectorAll("summary").forEach((summary) =>
        summary.addEventListener("click", this.onSummaryClick.bind(this))
      );
      this.querySelectorAll("button").forEach((button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
      );
    }

    onKeyUp(event) {
      if (event.code.toUpperCase() !== "ESCAPE") return;

      const openDetailsElement = event.target.closest("details[open]");
      if (!openDetailsElement) return;

      openDetailsElement === this.mainDetailsToggle
        ? this.closeMenuDrawer(
            event,
            this.mainDetailsToggle.querySelector("summary")
          )
        : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest(".has-submenu");
      const isOpen = detailsElement.hasAttribute("open");
      const reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );

      function addTrapFocus() {
        summaryElement.nextElementSibling.removeEventListener(
          "transitionend",
          addTrapFocus
        );
      }

      if (detailsElement === this.mainDetailsToggle) {
        if (isOpen) event.preventDefault();
        isOpen
          ? this.closeMenuDrawer(event, summaryElement)
          : this.openMenuDrawer(summaryElement);

        if (window.matchMedia("(max-width: 990px)")) {
          document.documentElement.style.setProperty(
            "--viewport-height",
            `${window.innerHeight}px`
          );
        }
      } else {
        setTimeout(() => {
          detailsElement.classList.add("menu-opening");
          summaryElement.setAttribute("aria-expanded", true);
          parentMenuElement && parentMenuElement.classList.add("submenu-open");
          !reducedMotion || reducedMotion.matches
            ? addTrapFocus()
            : summaryElement.nextElementSibling.addEventListener(
                "transitionend",
                addTrapFocus
              );
        });
      }
    }

    openMenuDrawer(summaryElement) {
      setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
      });
      summaryElement.setAttribute("aria-expanded", true);
      document.documentElement.classList.add(`overflow-hidden`);
    }

    closeMenuDrawer(event, elementToFocus = false) {
      if (event === undefined) return;

      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelectorAll(".submenu-open")
        .forEach((submenu) => {
          submenu.classList.remove("submenu-open");
        });
      document.documentElement.classList.remove(
        `overflow-hidden`
      );
      this.closeAnimation(this.mainDetailsToggle);
    }

    onFocusOut(event) {
      setTimeout(() => {
        if (
          this.mainDetailsToggle.hasAttribute("open") &&
          !this.mainDetailsToggle.contains(document.activeElement)
        )
          this.closeMenuDrawer();
      });
    }

    onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest("details");
      this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
      const parentMenuElement = detailsElement.closest(".submenu-open");
      parentMenuElement && parentMenuElement.classList.remove("submenu-open");
      detailsElement.classList.remove("menu-opening");
      detailsElement
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute("open");
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }

  customElements.define("menu-drawer", MenuDrawer);

  class TdHeaderDrawer extends MenuDrawer {
    constructor() {
      super();
    }

    openMenuDrawer(summaryElement) {
      this.header = this.header || document.querySelector(".header-section");
      this.header.classList.add("menu-open");
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom)}px`);
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
        document.documentElement.classList.add("td-header__mobile-menu--opened");
      });

      summaryElement.setAttribute("aria-expanded", true);
    }

    closeMenuDrawer(event, elementToFocus) {
      super.closeMenuDrawer(event, elementToFocus);
      this.header.classList.remove("menu-open");
      document.documentElement.classList.remove("td-header__mobile-menu--opened");
    }
  }

  customElements.define("td-header-drawer", TdHeaderDrawer);
}

class CustomAccordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('.custom-accordion__content');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }
}

document.querySelectorAll('details.custom-accordion').forEach((el) => {
  new CustomAccordion(el);
});